<script setup lang="ts">
  import { useHistoryStore } from "~/stores/HistoryStore";
  const historyStore = useHistoryStore();

  interface Props {
    planId: string;
  }
  defineProps<Props>();
</script>

<template>
  <v-btn
    size="small"
    variant="outlined"
    color="monochrome-01"
    class="review-btn text-center rounded px-2 mb-0 mb-sm-3"
    @click="historyStore.to(`/plan/${planId}/review`)"
  >
    この講座の体験談を投稿する
  </v-btn>
</template>

<style lang="scss" scoped>
  .review-btn {
    width: 280px;
    height: 56px;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.8em;
    letter-spacing: 0.06em;
    background-color: #ffffff00 !important;
    border: 1px solid #ffffff;
  }
</style>
